// extracted by mini-css-extract-plugin
module.exports = {"dpu-detail-C":"C_dpu-detail-C__grWyf"};